// Navigation des Moduls `admin` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul admin.
import {
  ChatsCircle,
  ClockCounterClockwise,
  EnvelopeSimple,
  Gauge,
  GearSix,
  Heartbeat,
  LockKey,
  PlugsConnected,
  Sparkle,
  TreeStructure,
  UserCircle,
} from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'admin',
  title: 'Admin panel',
  nav: {
    admin: [
      {
        key: 'admin.overview',
        label: 'Overview',
        icon: Gauge,
        path: '/',
        roles: ['ADM', 'HR', 'PERF', 'COMP', 'CL', 'CEO'],
        order: 10,
        area: 'Overview',
      },
      {
        key: 'admin.accounts',
        label: 'Accounts',
        icon: UserCircle,
        path: '/accounts',
        roles: ['ADM', 'HR'],
        order: 110,
        area: 'People ops',
      },
      {
        key: 'admin.org',
        label: 'Organisation',
        icon: TreeStructure,
        path: '/org',
        roles: ['ADM', 'HR', 'PERF'],
        order: 120,
        area: 'People ops',
        readOnly: ['PERF'],
      },
      {
        key: 'admin.assistant',
        label: 'Assistant',
        icon: Sparkle,
        path: '/assistant',
        roles: ['ADM'],
        order: 760,
        area: 'Knowledge',
      },
      {
        key: 'admin.roles',
        label: 'Roles & permissions',
        icon: LockKey,
        path: '/roles',
        roles: ['ADM', 'HR'],
        order: 810,
        area: 'System',
        readOnly: ['HR'],
      },
      {
        key: 'admin.settings',
        label: 'Settings',
        icon: GearSix,
        path: '/settings',
        roles: ['ADM', 'PERF'],
        order: 820,
        area: 'System',
        readOnly: ['PERF'],
      },
      {
        key: 'admin.audit',
        label: 'Audit log',
        icon: ClockCounterClockwise,
        path: '/audit',
        roles: ['ADM', 'HR', 'PERF', 'COMP', 'CEO'],
        order: 830,
        area: 'System',
      },
      {
        key: 'admin.integrations',
        label: 'Integrations',
        icon: PlugsConnected,
        path: '/integrations',
        roles: ['ADM'],
        order: 840,
        area: 'System',
      },
      {
        key: 'admin.chat',
        label: 'Chat',
        icon: ChatsCircle,
        path: '/chat',
        roles: ['ADM'],
        order: 850,
        area: 'System',
      },
      {
        key: 'admin.outbox',
        label: 'Dev outbox',
        icon: EnvelopeSimple,
        path: '/outbox',
        roles: ['ADM'],
        order: 860,
        area: 'System',
      },
      {
        key: 'admin.system',
        label: 'System health',
        icon: Heartbeat,
        path: '/system',
        roles: ['ADM'],
        order: 870,
        area: 'System',
      },
    ],
  },
});
